const sicknesscategory = {
  getlist: 'sicknesscategory/getlist',
  add: 'sicknesscategory/add',
  update: 'sicknesscategory/update',
  remove: 'sicknesscategory/remove',
  get: 'sicknesscategory/get',
  getall: 'sicknesscategory/getall',
}
export default sicknesscategory
